import { React, useState } from 'react'

import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css'
import { Image, Card, Button, Badge } from 'react-bootstrap'
import { BsGithub } from 'react-icons/bs'
import { projects } from './data'
const Projects = () => {
  // eslint-disable-next-line
  const [project, setprojects] = useState(projects)
  return (
    <>
      <h1 className='mb-4'>Projects</h1>
      {project.map((project) => {
        return (
          <Card bg='dark' className='mb-4' key={project.id}>
            <Card.Body>
              <h1>{project.title}</h1>
              <p className='text-muted'>{project.desc}</p>
              <div className='mb-3'>
                {project.tools.map((tool) => {
                  return (
                    <Badge
                      key={tool.id}
                      bg='light'
                      text='dark'
                      className='mx-1'
                    >
                      #{tool.name}
                    </Badge>
                  )
                })}
              </div>
              <Image src={project.image} fluid rounded className='mb-3' />

              <Button variant='light' href={project.link} target='_blank'>
                <BsGithub className='mx-1' />
                See Repository
              </Button>
            </Card.Body>
          </Card>
        )
      })}
    </>
  )
}

export default Projects
